// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

export default class TestMouseCursor {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }
    private _help?: vf.gui.Container;
    private _wait?: vf.gui.Container;
    private _crosshair?: vf.gui.Container;
    private _notAllowed?: vf.gui.Container;
    private _zoomIn?: vf.gui.Container;
    private _grab?: vf.gui.Container;
    private _img?: vf.gui.Container;
    private _buttonList: vf.gui.Label[] = [];



    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {

        // 支持说明
        // https://developer.mozilla.org/en-US/docs/Web/CSS/cursor  

        const help = this.getContainer();
        help.x = 100;
        help.y = 100;
        help.interactive = true; //激活交互 
        help.style.cursor = "help"; //鼠标状态
        uiStage.addChild(help);

        const wait = this.getContainer();
        wait.x = 220;
        wait.y = 100;
        wait.interactive = true; //激活交互 
        wait.style.cursor = "wait"; //鼠标状态
        uiStage.addChild(wait);

        const crosshair = this.getContainer();
        crosshair.x = 340;
        crosshair.y = 100;
        crosshair.interactive = true; //激活交互 
        crosshair.style.cursor = "crosshair"; //鼠标状态
        uiStage.addChild(crosshair);

        const notAllowed = this.getContainer();
        notAllowed.x = 100;
        notAllowed.y = 220;
        notAllowed.interactive = true; //激活交互 
        notAllowed.style.cursor = "not-allowed"; //鼠标状态
        uiStage.addChild(notAllowed);

        const zoomIn = this.getContainer();
        zoomIn.x = 220;
        zoomIn.y = 220;
        zoomIn.interactive = true; //激活交互 
        zoomIn.style.cursor = "zoom-in"; //鼠标状态
        uiStage.addChild(zoomIn);

        const grab = this.getContainer();
        grab.x = 340;
        grab.y = 220;
        grab.interactive = true; //激活交互 
        grab.style.cursor = "grab"; //鼠标状态
        uiStage.addChild(grab);

        const img = this.getContainer();
        img.x = 100;
        img.y = 340;
        img.interactive = true; //激活交互 
        img.style.cursor = "url(assets/pc.png), pointer"; //鼠标状态
        uiStage.addChild(img);



        this.getButton('设置/取消help', () => {
            if (help.style.cursor !== "") {
                help.style.cursor = "";


            } else {
                help.style.cursor = "help"
            }

        }, uiStage, 450, 0);


        this.getButton('设置/取消wait', () => {
            if (wait.style.cursor !== "") {
                wait.style.cursor = "";


            } else {
                wait.style.cursor = "wait";
            }

        }, uiStage, 450, 0);


        this.getButton('设置/取消crosshair', () => {
            if (crosshair.style.cursor !== "") {
                crosshair.style.cursor = "";


            } else {
                crosshair.style.cursor = "crosshair";
            }

        }, uiStage, 450, 0);



        this.getButton('设置/取消not-allowed', () => {
            if (notAllowed.style.cursor !== "") {
                notAllowed.style.cursor = "";


            } else {
                notAllowed.style.cursor = "not-allowed";
            }

        }, uiStage, 450, 0);



        this.getButton('设置/取消zoom-in', () => {
            if (zoomIn.style.cursor !== "") {
                zoomIn.style.cursor = "";


            } else {
                zoomIn.style.cursor = "zoom-in";
            }

        }, uiStage, 450, 0);



        this.getButton('设置/取消grab', () => {
            if (grab.style.cursor !== "") {
                grab.style.cursor = "";


            } else {
                grab.style.cursor = "grab";
            }

        }, uiStage, 450, 0);



        this.getButton('设置/取消url(assets/pc.png), pointer', () => {
            if (img.style.cursor !== "") {
                img.style.cursor = "";


            } else {
                img.style.cursor = "url(assets/pc.png), pointer";
            }

        }, uiStage, 450, 0);

    }

    private getContainer() {
        const container = new vf.gui.Container();
        container.width = 100;
        container.height = 100;
        container.style.backgroundColor = 100;
        return container
    }



    private posY = 10;
    private getButton(title: string, fun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 24;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, fun);
        target.addChild(button);
        this.posY = this.posY + 25 + y;
        this._buttonList.push(button);
        return button;
    }

    private onRelease() {
        if (this._help) {
            this._help.removeAllListeners();
            this._help.parent && this._help.parent.removeChild(this._help);
            this._help.release();
            this._help = undefined;
        }
        if (this._wait) {
            this._wait.removeAllListeners();
            this._wait.parent && this._wait.parent.removeChild(this._wait);
            this._wait.release();
            this._wait = undefined;
        }
        if (this._crosshair) {
            this._crosshair.removeAllListeners();
            this._crosshair.parent && this._crosshair.parent.removeChild(this._crosshair);
            this._crosshair.release();
            this._crosshair = undefined;
        }
        if (this._notAllowed) {
            this._notAllowed.removeAllListeners();
            this._notAllowed.parent && this._notAllowed.parent.removeChild(this._notAllowed);
            this._notAllowed.release();
            this._notAllowed = undefined;
        }
        if (this._zoomIn) {
            this._zoomIn.removeAllListeners();
            this._zoomIn.parent && this._zoomIn.parent.removeChild(this._zoomIn);
            this._zoomIn.release();
            this._zoomIn = undefined;
        }
        if (this._grab) {
            this._grab.removeAllListeners();
            this._grab.parent && this._grab.parent.removeChild(this._grab);
            this._grab.release();
            this._grab = undefined;
        }
        if (this._img) {
            this._img.removeAllListeners();
            this._img.parent && this._img.parent.removeChild(this._img);
            this._img.release();
            this._grab = undefined;
        }

        if (this._buttonList && this._buttonList.length > 0) {
            this._buttonList.forEach(element => {
                element.removeAllListeners();
                element.parent && element.parent.removeChild(element);
                element.release();
            });
            this._buttonList = [];
        }

    }
}
